(ns hai.notes.header
  "The tinted header row every notes surface shares: note icon + title (a
   link when `:href` is given) with action buttons on the right. `:dotted?`
   adds the perforated bottom edge. Actions come as children — hosts wrap
   their own `:button.bar-action-btn`s in tooltips as needed."
  (:require
   [hai.mini-apps.add-pill :as add-pill]
   [hai.ui.icons :as icons]
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]))

;; One height for every card header, with or without the ＋ pill: the minimum
;; governs and the row centres whatever it holds, so no vertical padding — it
;; would add to the tallest control and push a pill-bearing header past the
;; others. Border-box keeps the dotted edge inside the same 56px.
(o/defstyled bar :div
  {:display "flex" :align-items "center" :gap "10px"
   :padding "0 18px"
   :min-height "56px"
   :box-sizing "border-box"
   :background t/--notes
   :color t/--note-kraft}
  [:&.dotted
   {:border-bottom-width "2px"
    :border-bottom-style "dotted"
    :border-bottom-color t/--note-sage-35}]
  [:.bar-icon
   {:display "inline-flex" :align-items "center"
    :flex "0 0 auto"
    :color t/--note-kraft}
   ;; Stroke icon — undo the page's `svg {fill: currentColor}`.
   [:svg {:fill "none"}]]
  [:.bar-title
   {:font-size "16px" :font-weight "700" :line-height "1.2"
    :margin "0"
    :flex "0 0 auto"
    :white-space "nowrap"
    :letter-spacing "-0.005em"
    :color t/--note-kraft}]
  [:.bar-title-link
   {:display "inline-flex" :align-items "center" :gap "10px"
    :flex "0 0 auto"
    :color "inherit"
    :text-decoration "none"
    :cursor "pointer"}
   [:&:hover
    [:.bar-title {:text-decoration "underline" :text-underline-offset "3px"}]]]
  [:.bar-actions
   {:margin-left "auto"
    :display "flex" :align-items "center" :gap "6px"}]
  ;; The ＋ Note pill, in the deeper butter yellow the notes page fills its own
  ;; Add note button with.
  [add-pill/pill {:background t/--note-add-fill}]
  [:.bar-action-btn
   {:width "28px" :height "28px"
    :border "none" :border-radius "999px"
    :background "transparent"
    :padding "0"
    :color t/--note-kraft
    :cursor "pointer"
    :display "inline-flex" :align-items "center" :justify-content "center"
    :transition "background 0.15s ease"}
   [:&:hover {:background t/--note-kraft-10}]
   [:svg {:fill "currentColor"}]]
  ([{:keys [title href target rel dotted?]} & actions]
   ;; Keep the root fragment's first child a concrete element (never a bare
   ;; `[:<>]`): Ornament's fragment-flattening recurses into a leading `:<>`
   ;; child and drops its siblings, which would silently swallow the whole
   ;; `.bar-actions` group (the ⋮ and ✕).
   (into
    [:<> {:class (when dotted? "dotted")}]
    (concat
     (if href
       [[:a.bar-title-link {:href href :target target :rel rel}
         [:span.bar-icon [icons/note {:size 18}]]
         [:h2.bar-title title]]]
       [[:span.bar-icon [icons/note {:size 18}]]
        [:h2.bar-title title]])
     [(into [:div.bar-actions] actions)]))))
